import React from 'react';
import Icon from '../../../components/AppIcon';

const NavigationPanel = ({ 
  activeSection, 
  setActiveSection, 
  providers = [],
  kycDocuments = [],
  staffMembers = [],
  users = [],
  subscriptions = []
}) => {
  const sections = [
    {
      id: 'provider-verification',
      label: 'Provider Verification',
      icon: 'CheckCircle',
      description: 'Service provider approval workflow',
      count: providers?.filter(p => p?.status === 'pending')?.length || 0,
      color: 'text-blue-600'
    },
    {
      id: 'kyc-review',
      label: 'KYC Review',
      icon: 'FileText',
      description: 'Document verification & KYC',
      count: kycDocuments?.filter(doc => doc?.status === 'pending')?.length || 0,
      color: 'text-orange-600'
    },
    {
      id: 'staff-directory',
      label: 'Staff Directory',
      icon: 'Users',
      description: 'Staff management & mapping',
      count: staffMembers?.filter(staff => staff?.status === 'pending')?.length || 0,
      color: 'text-green-600'
    },
    {
      id: 'user-controls',
      label: 'User Controls',
      icon: 'Settings',
      description: 'User activation & management',
      count: users?.filter(user => user?.status === 'suspended')?.length || 0,
      color: 'text-red-600'
    },
    {
      id: 'financial-management',
      label: 'Financial Management',
      icon: 'CreditCard',
      description: 'Subscriptions & payouts',
      count: subscriptions?.filter(sub => sub?.status === 'active')?.length || 0,
      color: 'text-purple-600'
    }
  ];

  return (
    <div className="w-80 bg-card border-r border-border overflow-y-auto">
      {/* Section Navigation */}
      <div className="p-4">
        <h3 className="text-sm font-medium text-muted-foreground mb-4">Management Sections</h3>
        <div className="space-y-2">
          {sections?.map((section) => (
            <button
              key={section?.id}
              onClick={() => setActiveSection?.(section?.id)}
              className={`w-full flex items-center justify-between p-3 rounded-lg text-left transition-all ${
                activeSection === section?.id
                  ? 'bg-primary text-primary-foreground'
                  : 'hover:bg-muted text-muted-foreground hover:text-foreground'
              }`}
            >
              <div className="flex items-center space-x-3">
                <Icon 
                  name={section?.icon} 
                  size={20} 
                  className={activeSection === section?.id ? 'text-primary-foreground' : section?.color}
                />
                <div>
                  <div className={`font-medium text-sm ${
                    activeSection === section?.id ? 'text-primary-foreground' : 'text-foreground'
                  }`}>
                    {section?.label}
                  </div>
                  <div className={`text-xs ${
                    activeSection === section?.id ? 'text-primary-foreground/70' : 'text-muted-foreground'
                  }`}>
                    {section?.description}
                  </div>
                </div>
              </div>
              {section?.count > 0 && (
                <span className={`inline-flex items-center justify-center px-2 py-1 text-xs font-bold rounded-full ${
                  activeSection === section?.id 
                    ? 'bg-primary-foreground text-primary' 
                    : 'bg-primary text-primary-foreground'
                }`}>
                  {section?.count}
                </span>
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Recent Activity */}
      <div className="border-t border-border p-4">
        <h3 className="text-sm font-medium text-muted-foreground mb-4">Recent Activity</h3>
        <div className="space-y-3">
          <div className="flex items-start space-x-3">
            <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
            <div className="text-xs text-muted-foreground">
              New provider verification request from TechFix Solutions
            </div>
          </div>
          <div className="flex items-start space-x-3">
            <div className="w-2 h-2 bg-orange-500 rounded-full mt-2 flex-shrink-0"></div>
            <div className="text-xs text-muted-foreground">
              KYC document submitted by Alice Cooper
            </div>
          </div>
          <div className="flex items-start space-x-3">
            <div className="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></div>
            <div className="text-xs text-muted-foreground">
              New staff member Emma Thompson added
            </div>
          </div>
          <div className="flex items-start space-x-3">
            <div className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0"></div>
            <div className="text-xs text-muted-foreground">
              User Carol Davis account suspended
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavigationPanel;